export const allowedFormats = {
    png: 'PNG',
    jpg: 'JPG',
    jpeg: 'JPEG',
    mp4: 'MP4',
    //wmv: 'WMV',
    wma: 'WMA',
    pdf: 'PDF',
    doc: 'DOC',
    docx: 'DOCX',
    xls: 'XLS',
    xlsx: 'XLSX',
    ppt: 'PPT',
    pptx: 'PPTX',
    txt: 'TXT',
    //csv: 'CSV',
};